<template>
  <el-dialog :visible.sync="domVisible" custom-class="contact" :lock-scroll="false" :before-close="DialogClose">
    <div id="ContactUS">
      <img src="../../../static/images/icon/contactUS_bg.svg" />
      <h4>{{$t('alert.contactUs')}}</h4>
      <!-- <p>{{$t('alert.sendEmail')}}</p> -->
      <ul v-if="AreaCode!='KR'">
        <li>
          <div class="title">1. Shipping Inquiries</div>
          <div class="name">For all matters related to weight, shipping, tracking question</div>
          <!-- <div class="copy">customer@cardhobbysupport.com<span @click="CopyLink('customer@cardhobbysupport.com')">{{$t('base.copy')}}</span></div> -->
        </li>
        <li>
          <div class="title">2. U.S. Buyer Support</div>
          <div class="name">If you have questions or concerns specifically related to being a U.S. buyer, your purchases, orders, or any other U.S.-related matters</div>
          <!-- <div class="copy">customer@cardhobbysupport.com<span @click="CopyLink('customer@cardhobbysupport.com')">{{$t('base.copy')}}</span></div> -->
        </li>
        <li>
          <div class="title">3. Becoming a U.S. Seller or General Inquiries</div>
          <div class="name">If you are interested in becoming a U.S. seller with Card Hobby or if you have any other general inquiries, please contact us at</div>
          <div class="copy">customer@cardhobbysupport.com<span @click="CopyLink('customer@cardhobbysupport.com')">{{$t('base.copy')}}</span></div>
        </li>
      </ul>
      <ul :class="AreaCode" v-if="AreaCode=='KR'">
        <li>
          <div class="name">카드하비 코리아에 문의 사항이 있으신가요?</div>
          <div class="name"><span class="copy" @click="CopyLink('cs@cardhobby.kr')">cs@cardhobby.kr</span> 로 문의하시면 순차적으로 답변드리겠습니다.
답변에는 최대 5 영업일이 소요될 수 있습니다.</div>
          <div class="name">감사합니다.</div>
        </li>
      </ul>
      <!-- <div class="copy">cardhobby03@yahoo.com<span @click="CopyLink('cardhobby03@yahoo.com')">{{$t('base.copy')}}</span></div> -->
    </div>
  </el-dialog>
</template>
<script>
import qs from 'qs'
import { getInfo } from "@/api/public";
export default {
  name: '',
  data() {
    return {
      AreaCode: 'US',
      userInfo: "",
      dialogTitle: '',
      isCopy: false
    }
  },
  props: {
    domVisible: Boolean,
  },
  watch: {},
  filters: {},
  mounted() {},
  created() {
    this.userInfo = getInfo()
    this.isUser()
  },
  methods: {
    setAreaData() {
      let AreaData = this.$enumInfo.AreaData
      var navlanguage = window.navigator.language
      console.log(navlanguage,'navlanguage')
      var data='US'
      AreaData.map(res => {
        if (res.browserLanguages == navlanguage) {
          data=res.areaCode
        }
      })
      return data
    },
    isUser() {
      let that = this
      if (that.userInfo) {
        that.AreaCode = "US"
        if (that.userInfo.MemberSource == 'KR') {
          that.AreaCode = that.userInfo.MemberSource
        }
      }else{
        that.AreaCode = that.setAreaData()
      }
    },
    // 复制
    CopyLink(val) {
      let that = this
      this.$copyText(val).then(function(e) {
        that.isCopy = true
        that.$message({
          message: 'Copy Successfully',
          type: 'success'
        });
      }, function(e) {
        that.isCopy = false
        that.$message.error('Fail');
      })
    },
    DialogClose() {
      this.$root.$emit("contactUS", false);
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#ContactUS {
  text-align: center;
  position: relative;
  padding-bottom: 40px;
}

#ContactUS>img {
  width: 242px;
  height: 174px;
  margin-top: 60px;
}

#ContactUS>h4 {
  font-size: 20px;
  font-weight: 700;
  color: #5F6DAE;
  margin-top: 15px;
}

#ContactUS>p {
  margin: 20px 0;

}

#ContactUS .title {
  color: #333;
  font-weight: 700;
}

#ContactUS .name {
  color: #333;
  margin: 8px 0;
}

#ContactUS .copy {
  color: #5F6DAE;
}

#ContactUS ul {
  width: 640px;
  margin: 0 auto;
}

#ContactUS ul li {
  margin-top: 24px;
}

#ContactUS .copy>span {
  cursor: pointer;
  position: relative;
  padding-left: 18px;
  margin-left: 10px;
}

#ContactUS .copy>span:before {
  content: '';
  background: url(../../../static/images/icon/icon_copy.svg);
  width: 17px;
  height: 16px;
  position: absolute;
  left: 0;
}
#ContactUS .KR .copy>span:before{
  background: none;
}
#ContactUS .KR .copy{
  cursor: pointer;
  color: #5F6DAE;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/contact.vue